import React, { Component, Fragment } from "react"
import moment from "moment"

//services
import { UtilityService } from "../../services"

export default class PrintSmv extends Component {
  state = {
    smvObData: {}
  }

  componentWillMount() {
    const { smvObData } = this.props
    this.setState({
      smvObData
    })
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.smvObData != this.props.smvObData) {
      this.setState({
        smvObData: nextProps.smvObData
      })
      //   this.calculateTotal()
    }
  }
  render() {
    const { smvObData } = this.state
    const {
      threadCalculation,
      smv,
      styleReferenceId,
      sampleType,
      magnumStyleName,
      customerName,
      departmentName,
      sampleDate,
      size,
      selectedsize,
      chartPreparedOn,
      firstName,
      lastName,
      totalSam,
      minutesPerDay,
      target100,
      target80
    } = smvObData
    const {
      threadCalculationArray,
      totalVal,
      totalNeedle,
      totalLooper,
      totalOverLock,
      totalTrimThread,
      totalSheeringNeedle,
      wastage,
      add,
      otherSizes,
      totalNeedleRound,
      wash,
      totalLooperRound,
      totalOverLockRound,
      totalTrimThreadRound,
      totalSheeringNeedleRound,
      allSizes
    } = threadCalculation
    return (
      <Fragment>
        <div className="fabricPrintDiv">
          <style>
            {`@media print {
                body{
                    font-family: 'Montserrat', sans-serif;
                    font-size:12px;
                }
                .fabricPrintDiv{
                    border : 2px solid black;
                    top : 0;
                    bottom : 0;
                }

                .printrow {

                    width: 100%;
                }

                .printcolumn {
                    display: flex;
                    flex-direction: column;
                    flex-basis: 100%;
                    flex: 1;
                }
                table>tbody>tr td{
                    font-size:12px;
                    text-align:center;
                }
                .label-text{
                    color:#279588;
                    font-size : 12px;
                    font-weight:bold;
                }
                .blue{
                    color : #146FF9;
                }
                .padding-for-heading{
                    padding: 5px;
                }


                .specialComments{
                    width: 75%;
                    border : 1px solid black;
                    height : 60px;
                    margin: 10px;
                }

                .b{
                    border: 1px solid black;
                    margin: 10px;
                    padding: 5px;
                }
                .fabric-text{
                    font-size:16px;
                    color: #279588;
                    font-weight: 1000;
                }

                .bold{
                    font-weight:bold;
                }
                .bb-p{
                    border-bottom: 1px solid black;
                    margin-bottom: 10px ;
                }
                .w-50 {
                    width: 50%;
                }
                table.grid{
                    border-collapse: collapse;
                    margin-right: 5px;
                    margin-left: 5px;
                }
                table.grid>tbody>tr td {
                    border: 0.5px solid black;
                    text-align: center;
                    padding: 2px;
                }
                .width-for-table{
                    width: 50%;
                }
                .text-center{
                    text-align: center;
                }
                .p-1{
                    padding : 5px;
                }
                .pl-1{
                    padding-left: 23px;
                }
                .border-bot{
                    border-bottom : 1px solid black;
                }
                .mt{
                    margin-top:10px;
                }
                .mtl{
                    margin-top:30px;
                }
                .margin{
                    margin : 5px;
                }
                .pl-2{
                    padding: 5px;
                }
                .table-heading{
                    padding-left:5px;
                    margin:0;
                    color:#4285f4;
                    text-transform:uppercase;

                }

                .text-capitalize{
                    text-transform: capitalize;
                }

                .padding-option{
                    padding:0px 20px 0px 20px;

                }
                .paddingleft{
                    padding-left:25px !important;
                }
                table{
                    width:100%;
                }
                .test-class{
                    width:40%;

                    display:inline-block
                }
                .test-class1{
                    width:20%;
                    display:inline-block
                }
                .test-class2{
                    width:40%;
                    display:inline-block
                }

                .float-left{
                    float:left !important;
                }
                .text-right{
                    text-align:right !important;
                }
                .text-left{
                    text-align:left !important;
                }
                .padding-top-align{
                    padding-top:15px !important;
                }
                }`}
          </style>
          <div className="bold text-center p-1 ">
            Create SMV/OB and Thread Consumption
          </div>
          <div className="printrow bb-p">
            <div className="text-capitalize">
              {/* SMV/OB TABLE START */}
              <table>
                <tr>
                  <th></th>
                  <th></th>
                  <th></th>
                </tr>
                <tbody>
                  <tr>
                    <td className="label-text">style no</td>
                    <td className="label-text">style name</td>
                    <td className="label-text">customer name</td>
                  </tr>
                  <tr>
                    <td className="bold">{styleReferenceId}</td>
                    <td className="bold">{magnumStyleName}</td>
                    <td className="bold">{`${customerName}/${departmentName}`}</td>
                  </tr>
                  <tr>
                    <td className="label-text">sample type</td>
                    <td className="label-text">sample date</td>
                    <td className="label-text">size</td>
                    <td className="label-text">chart prepared on</td>
                    <td className="label-text">chart prepared by</td>
                  </tr>
                  <tr>
                    <td className="bold">{sampleType}</td>
                    <td className="bold">
                      {moment(sampleDate).format("HH:mm DD MMM YYYY")}
                    </td>
                    <td className="bold">{size}</td>
                    <td className="bold">
                      {moment(chartPreparedOn).format("HH:mm DD MMM YYYY")}
                    </td>
                    <td className="bold">{`${firstName} ${lastName}`}</td>
                  </tr>
                </tbody>
              </table>
              {/* SMV/OB TABLE TABLE END */}
            </div>
          </div>

          <div className="printrow bb-p">
            <div className="text-capitalize">
              <table>
                <tbody>
                  <tr>
                    <td className="label-text">s.no</td>
                    <td className="label-text">operations</td>
                    <td className="label-text">machine</td>
                    <td className="label-text">folder/guide</td>
                    <td className="label-text">seconds</td>
                    <td className="label-text">SAM</td>
                    <td className="label-text">target per hour</td>
                  </tr>

                  {smv &&
                    smv.length > 0 &&
                    smv.map((value, index) => {
                      return (
                        <tr>
                          <td className="bold">{value.index}</td>
                          <td className="bold">{value.operations}</td>
                          <td className="bold">{value.machine}</td>
                          <td className="bold">{value.folder}</td>
                          <td className="bold">{value.seconds}</td>
                          <td className="bold">{value.sam}</td>
                          <td className="bold">{value.targetPerHour}</td>
                        </tr>
                      )
                    })}

                  <tr>
                    <td colspan="5" className="label-text text-right">
                      Total SAM
                    </td>
                    <td className="bold">{totalSam}</td>
                  </tr>
                  <tr>
                    <td colspan="2" className="label-text text-right">
                      MINUTES PER DAY
                    </td>
                    <td className="bold">{minutesPerDay}</td>
                  </tr>
                  <tr>
                    <td colspan="2" className="label-text text-right">
                      100% TARGET
                    </td>
                    <td className="bold">{target100}</td>
                    <td className="bold">PCS PER TAILOR</td>
                  </tr>
                  <tr>
                    <td colspan="2" className="label-text text-right">
                      80% TARGET
                    </td>
                    <td className="bold">{target80}</td>
                    <td className="bold">PCS PER TAILOR</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div className="printrow bb-p">
            <div className="text-capitalize">
              <p className="bold text-center">Thread Consumption</p>

              <table className="w-100">
                <tr>
                  <th></th>
                  <th></th>
                  <th></th>
                </tr>
                <tbody>
                  <tr>
                    <td className="label-text">s.no</td>
                    <td className="label-text">operations</td>
                    <td className="label-text">machine</td>
                    <td className="label-text">length</td>
                    <td className="label-text">factor</td>
                    <td className="label-text">rating</td>
                    <td className="label-text">total</td>
                    <td className="label-text">needle</td>
                    <td className="label-text">looper</td>
                    <td className="label-text">over lock</td>
                    <td className="label-text">TRD Elastic</td>
                    <td className="label-text">sheering needle</td>
                  </tr>
                  {threadCalculationArray &&
                    threadCalculationArray.length > 0 &&
                    threadCalculationArray.map((value, index) => {
                      return (
                        <tr>
                          <td className="bold">{value.index}</td>
                          <td className="bold">{value.operation}</td>
                          <td className="bold">{value.machine}</td>
                          <td className="bold">{value.length}</td>
                          <td className="bold">{value.factor}</td>
                          <td className="bold">{value.rating}</td>
                          <td className="bold">
                            {Number(value.total).toFixed(2)}
                          </td>
                          <td className="bold">
                            {Number(value.needle).toFixed(2)}
                          </td>
                          <td className="bold">
                            {Number(value.looper).toFixed(2)}
                          </td>
                          <td className="bold">
                            {Number(value.overLock).toFixed(2)}
                          </td>
                          <td className="bold">
                            {Number(value.trimThread).toFixed(2)}
                          </td>
                          <td className="bold">
                            {Number(value.sheeringNeedle).toFixed(2)}
                          </td>
                        </tr>
                      )
                    })}

                  <tr>
                    <td colspan="6" className="label-text text-right ">
                      Total:{" "}
                    </td>
                    <td className="bold">{totalVal}</td>
                    <td className="bold">{totalNeedle}</td>
                    <td className="bold">{totalLooper}</td>
                    <td className="bold">{totalOverLock}</td>
                    <td className="bold">{totalTrimThread}</td>
                    <td className="bold">{totalSheeringNeedle}</td>
                  </tr>
                  <tr>
                    <td colspan="2" className="label-text text-right">
                      Wastage
                    </td>
                    <td className="bold">{wastage}%</td>
                    <td colspan="3"></td>
                    <td className="bold"></td>
                    <td className="bold"></td>
                    <td className="bold"></td>
                    <td className="bold"></td>
                    <td className="bold"></td>
                  </tr>
                  <tr>
                    <td colspan="2" className="label-text text-right">
                      Other sizes
                    </td>
                    <td className="bold">{otherSizes} %</td>
                  </tr>
                  <tr>
                    <td colspan="2" className="label-text text-right">
                      Wash
                    </td>
                    <td className="bold">{wash} %</td>
                    <td colspan="3"></td>
                    <td className="bold"></td>
                    <td className="bold"></td>
                    <td className="bold"></td>
                    <td className="bold"></td>
                    <td className="bold"></td>
                  </tr>
                  <tr>
                    <td colspan="7"></td>
                    <td className="label-text">Needle</td>
                    <td className="label-text">looper</td>
                    <td className="label-text">over lock</td>
                    <td className="label-text">TRD Elastic</td>
                    <td className="label-text">sheering needle</td>
                  </tr>
                  <tr>
                    <td colspan="2" className="label-text text-right">
                      Add %
                    </td>
                    <td className="bold">{wash + otherSizes + wastage}%</td>
                    <td
                      colspan="3"
                      className="label-text text-right padding-top-align"
                    >
                      Total MTRS of REQD (Incl. Add%)
                    </td>
                    <td className="bold"></td>
                    <td className="bold">{totalNeedleRound}</td>
                    <td className="bold">{totalLooperRound}</td>
                    <td className="bold">{totalOverLockRound}</td>
                    <td className="bold">{totalTrimThreadRound}</td>
                    <td className="bold">{totalSheeringNeedleRound}</td>
                  </tr>
                  <tr>
                    <td className="label-text">Size</td>
                    <td className="bold">{selectedsize}</td>
                  </tr>
                  <tr>
                    <td colspan="7"></td>
                    <td className="bold"></td>
                    <td className="bold"></td>
                    <td className="bold"></td>
                    <td className="bold"></td>
                  </tr>
                  <tr>
                    <td colspan="2" className="label-text text-right"></td>
                    <td className="bold"></td>
                    <td colspan="3"></td>
                    {/* <td className="label-text text-right">Total thread</td>
                                        <td className="bold">{totalVal}</td>
                                        <td className="bold">MTRS</td> */}
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          {/* DISPATCH'S INFO TABLE END */}
        </div>
      </Fragment>
    )
  }
}


// WEBPACK FOOTER //
// ./src/pages/SmvThread/printSmv.js